export default __webpack_public_path__ + "static/media/ic-it.d6691c19.svg";